import React from 'react';
import {Provider} from 'react-redux';
import {Route, Routes} from 'react-router-dom';
import {HistoryRouter} from 'redux-first-history/rr6';
import AppLayout from 'layouts/AppLayout';
import history from './history';
import store from './store';

class Root extends React.Component {

    render() {
        return <Provider store={store}>
            <HistoryRouter history={history}>
                <Routes>
                    <Route path="*" element={<AppLayout/>}/>
                </Routes>
            </HistoryRouter>
        </Provider>;
    }

}

export default Root;
